// Turkish display formatting shared by screens (mirrors worker-side labels).

import type { GameFormat, GameStatus, SkillLevel } from '@shared/models';

const TR_DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
const TR_MONTHS = [
  'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara',
];

export const SKILL_TR: Record<SkillLevel, string> = {
  beginner: 'Başlangıç',
  intermediate: 'Orta',
  advanced: 'İleri',
};

export const FORMAT_TR: Record<GameFormat, string> = {
  '3v3': '3v3',
  '4v4': '4v4',
  '5v5': '5v5',
  pickup: 'Serbest',
};

export const STATUS_TR: Record<GameStatus, string> = {
  open: 'Açık',
  full: 'Dolu',
  cancelled: 'İptal',
  completed: 'Tamamlandı',
};

/** "Çarşamba 20:00" */
export function whenShort(iso: string): string {
  const d = new Date(iso);
  const hh = d.getHours().toString().padStart(2, '0');
  const mm = d.getMinutes().toString().padStart(2, '0');
  return `${TR_DAYS[d.getDay()]} ${hh}:${mm}`;
}

/** "Çarşamba, 2 Eki · 20:00" */
export function whenLong(iso: string): string {
  const d = new Date(iso);
  const hh = d.getHours().toString().padStart(2, '0');
  const mm = d.getMinutes().toString().padStart(2, '0');
  return `${TR_DAYS[d.getDay()]}, ${d.getDate()} ${TR_MONTHS[d.getMonth()]} · ${hh}:${mm}`;
}

export const skillClass = (s: SkillLevel): string => `skill--${s}`;
